/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { motion } from 'framer-motion';

import Typo from 'uikit/content/components/typo';

import styles from '../styles/uikitProgressProgress.module.scss';

const Progress = ({
  size = 'medium',
  value = 0,
  ariaLabel = '',
  className = '',
  shouldAnimate = false,
  shouldShowTextPercentage = false,
  testId = '',
}) => {
  const defaultPercentage = shouldAnimate ? 0 : value;
  const [percentage, setPercentage] = useState(defaultPercentage);

  const SIZES = {
    small: {
      class: styles.isSizeSmall,
    },
    medium: {
      class: styles.isSizeMedium,
    },
    large: {
      class: styles.isSizeLarge,
    },
  };

  useEffect(() => {
    if (percentage !== value && shouldAnimate) {
      const duration = 2000 / value;
      const timer = setInterval(() => {
        setPercentage(percentage + 1);
      }, duration);

      return () => clearInterval(timer);
    }
    if (!shouldAnimate) {
      setPercentage(value);
    }
  });

  if (value < 0 || value > 100) {
    console.warn('Progress: Value must not be less than 0 or more than 100');
    return null;
  }

  const attributes = shouldAnimate
    ? {
        initial: { width: '0%' },
        animate: { width: `${value}%` },
        transition: { ease: 'linear', duration: 2 },
      }
    : {};

  return (
    <div
      aria-label={ariaLabel}
      aria-valuenow={value}
      aria-valuemin="0"
      aria-valuemax="100"
      className={classnames(styles.element, className)}
      data-testid={testId}
      role="progressbar"
    >
      <div className={styles.content}>
        <motion.div
          className={classnames(styles.bar, {
            [styles.isAnimatable]: shouldAnimate,
            [SIZES[size].class]: size,
          })}
          style={{ width: `${value}%` }}
          {...attributes}
        >
          {shouldShowTextPercentage && <Typo className={styles.count}>{`${percentage}%`}</Typo>}
        </motion.div>
      </div>
    </div>
  );
};

Progress.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  value: PropTypes.number,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  shouldAnimate: PropTypes.bool,
  shouldShowTextPercentage: PropTypes.bool,
  testId: PropTypes.string,
};

export { Progress as ProgressStorybook };
export default React.memo(Progress);
